export const isInIFrame = () => window.location !== window.parent.location;
